export function IFrame({ url, iframeRef  }) {

    return (
        <iframe src={url} width="100%" height="100%" frameBorder="0" title='iframe' ref={iframeRef} />
    );
}